import React from 'react';
import classNames from 'classnames';

class PageBanner extends React.Component {
    state = {
        bannerHeight: (typeof window == 'undefined') || (window.innerWidth > 880) ? '22.5em' : (window.innerWidth * 0.2875) + 'px'
    }

    resizeTimeout;

    resizeHandler() {
        this.setState({
            bannerHeight: (typeof window == 'undefined') || (window.innerWidth > 880) ? '22.5em' : (window.innerWidth * 0.2875) + 'px'
        })
    }

    resizeHandlerGateway() {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(this.resizeHandler.bind(this), 100);
    }

    componentDidMount() {
        if (typeof window != 'undefined') {
            window.addEventListener("resize", this.resizeHandlerGateway.bind(this));
        }
    }

    componentWillUnmount() {
        if (typeof window != 'undefined') {
            window.removeEventListener("resize", this.resizeHandlerGateway.bind(this));
        }
    }

    render() {
        const { className } = this.props;
        const bannerBoxClasses = classNames(
            'campaign-banner-box',
            className,
        );

        return (
            <div className={bannerBoxClasses}>
                <div key="image-banner" className='campaign-banner-inner cover-image-cont'>
                    {
                        this.props.children
                    }
                </div>
            </div>
        );
    }
}

export default PageBanner;
